//DSS Documentation on Angular Components - http://tiny.sc/cgangularcomponent
import { Component, EventEmitter, OnInit, AfterViewInit, Input, Output, Pipe, PipeTransform, HostListener, ViewChild } from '@angular/core';
import { NgModule } from '@angular/core';
//import { ViewChild, ElementRef } from '@angular/core';
import { func, bool } from 'prop-types';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ApiResult } from '@soco/core';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { SocoModalService } from '@soco/modal';
import { DatePipe } from '@angular/common';
import { ScheduleService } from './schedule.service';
import { DBTraceLogService } from '../shared/services/dbTraceLog/dbTraceLog.service';
import { CoolEmailService } from '../shared/services/coolEmail/coolEmail.service';
import { AppCommonService } from '../shared/services/common/app-common.service';
import {
    ScheduleOrder, AGLCScheduleOrder, SchedulingElgibleOrders, SchedulingElgibleLDCs
} from './schedule-entities';
import { DBTraceLog, LogType } from '../shared/services/dbTraceLog/dbTraceLog-entities';
import { AppConfigurationData } from '../shared/services/common/app-common-entities';
import { SocoHttpService } from '@soco/http';
import { MatStepper } from '@angular/material/stepper';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AvailabilityInput, AvailabilityOutput } from '../shared/components/availability/availability-selection-entities';
import { AccountVerificationInput, AccountVerificationOutput, AccountDetails } from '../shared/components/accountverification/account-verification-entities';
import { AppointmentConfirmationInput, AppointmentConfirmationOutput } from '../shared/components/appointmentconfirmation/appointment-confirmation-entities';
import { AppBaseComponent } from '../shared/components/base/app-base.component';
import { BnNgIdleService } from 'bn-ng-idle';
import { interval } from 'rxjs';

@Component({
    templateUrl: 'schedule.component.html',
    styleUrls: ['schedule.component.css', 'schedule.component.scss'],
    providers: [DatePipe, ScheduleService, DBTraceLogService, CoolEmailService, AppCommonService]
})
export class ScheduleComponent extends AppBaseComponent implements OnInit {

    @ViewChild(MatStepper, { static: false }) schedulingStepper: MatStepper;
    //@ViewChild(AvailabilityComponent, { static: false }) availabilityCopm: AvailabilityComponent;

    //#region Variables
    public ldc: any = '';
    public ldcFullName: string;
    public seedDate: string;
    public selectedTimeSlot: string = '';
    public selectdScheduleDate: string;
    public selectedScheduleWindow: string = '';
    public selectedTimeSlotWindow: string;
    public ccbAppointmentStart: string;
    public ccbAppointmentEnd: string;
    //public data: any;
    public isPageLoadReady: boolean = false;
    public isAvailabilityCallCompleted: boolean = false;
    public showInitialSpinner: boolean = false;
    public showSpinner: boolean = false;
    public showError: boolean = false;
    public showTimeSlotLoadingSpinner: boolean = false;
    public showConfirmSpinner: boolean = false;
    public showLogOut: boolean = false;
    public fieldInstructions: string = '';
    public requestorName: string = '';
    public gateCode: string = '';
    public intersectingStreet: string = '';
    public subdivisionName: string = '';

    verificationForm: FormGroup;
    verifyAddressForm: FormGroup;
    questionsForm: FormGroup;
    scheduleForm: FormGroup;
    confirmForm: FormGroup;
    successForm: FormGroup;
    //accntVerifyFormGroup: FormGroup;
    isLinear = false;

    public scheduleOrder: ScheduleOrder;
    public aglcScheduleOrder: AGLCScheduleOrder;
    public accountDetails: AccountDetails;
    public appConfigurationDataList: Array<AppConfigurationData> = [];
    public firstSentinelAvailableDate: string = '';
    public maxAvailableDatesAllowed: number = 0;
    public orderType: any = '';
    public cisOrderType: string = '';
    public invalidURLError: boolean = false;
    public isKMITextOptedIn: boolean = false;

    //public qrValue: string = 'https://ua-kmi.southernco.com/schedule/cgc/reconnect';

    public kmiPhoneNumber: string = '';
    public telMask = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
    public entranceInstructionsList = [];
    public contactPhoneNo: string = '';
    public contactHours: string = '';
    public isValidateAccountPerformed: boolean = false;
    public kmiPhoneNumberValidationMsg: string = '';
    public reqNameValidationMsg: string = '';
    public isQuestionnaireHasYes: boolean = true;
    public questionnaireList = [];
    public questionnaireQnAnswerList = [];
    public skipQuestionnaire: boolean = false;
    public isSentinelForceWindowEligible = true;    
    public deviceInfo = null;
    public dbTraceLog: DBTraceLog;
    public logReferenceID: string = '';
    public entranceCodeReminderMsg: string = '';
    public accountNumber: string = '';
    public availabilityInput: AvailabilityInput;
    public availabilityOutput: AvailabilityOutput;
    public accountVerificationInput: AccountVerificationInput;
    public accountVerificationOutput: AccountVerificationOutput;
    public appointmentConfirmationInput: AppointmentConfirmationInput;
    public emailToList: string;
    public specialFeeMsg: string = '';
    public acntNumberFromURL: string = '';
    public urlSource: string = '';
    public sessionTimeoutWarningMsg: string = '';
    public sessionExpired: boolean = true;
    public timeOutPeriod: number = 3000;
    public timeOutWarning: number = 30;
    public userActivity: any;
    public interval: any;
    public aglcScheudlingPortalSwitch: boolean = true;
    //#endregion

    constructor(public scheduleService: ScheduleService, private route: ActivatedRoute, private formBuilder: FormBuilder,
        public datepipe: DatePipe, public http: SocoHttpService, public deviceService: DeviceDetectorService,
        public dbTraceLogService: DBTraceLogService, public coolEmailService: CoolEmailService, private appCommonService: AppCommonService,
        private bnIdle: BnNgIdleService) {

        //Parent component initialization
        super(http, dbTraceLogService, coolEmailService, deviceService);

        try {

            //console.log('this.route.snapshot.url: ', this.route.snapshot.url);

            this.setRouteParameters();

            this.availabilityInput = new AvailabilityInput();
            this.availabilityOutput = new AvailabilityOutput();
            this.accountVerificationInput = new AccountVerificationInput();
            this.accountVerificationOutput = new AccountVerificationOutput();
            this.appointmentConfirmationInput = new AppointmentConfirmationInput();

            this.accountDetails = new AccountDetails();
            this.logReferenceID = this.datepipe.transform(Date.now(), "MMddyyyyHHmmss");

            if (this.urlSource != '')
                this.insertDBTraceLog(LogType.Info, 'Scheduling component initiated successfully from Source: ' + this.urlSource);
            else
                this.insertDBTraceLog(LogType.Info, 'Scheduling component initiated successfully');        

        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while loading scheduling constructor, Error: ' + e.message.substring(0, 500));
        }
    };

    ngOnInit() {
        try {
            //Initiate stepper forms
            this.verificationForm = this.formBuilder.group({});
            this.verifyAddressForm = this.formBuilder.group({});
            this.questionsForm = this.formBuilder.group({});
            this.scheduleForm = this.formBuilder.group({});
            this.confirmForm = this.formBuilder.group({});
            this.successForm = this.formBuilder.group({});
            
            if (Object.values(SchedulingElgibleOrders).includes(this.orderType.trim().toUpperCase()) &&
                Object.values(SchedulingElgibleLDCs).includes(this.ldc.trim().toUpperCase()))
            {
                //Start Loading Default/Initial values once correct URL is detected
                this.setDefaultValues();
                this.loadInitialData();
            }
            else {
                this.insertDBTraceLog(LogType.Error, 'Invalid URL detected');
                this.invalidURLError = true;
                $('#divScheduling').hide();
            }
        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while loading ngOnInit, Error: ' + e.message.substring(0, 500));
        }

    }

    //#region Init Methods
    public loadInitialData() {
        try {
            //Set Entrance Instructions
            //this.setEntranceInstructions();

            //Get KMI Application Data
            this.showInitialSpinner = true;
            this.GetApplicationConfigs();
            
            //Load special messages
            this.getSpecialMessagesByOrder();
            
        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while loading initial data, Error: ' + e.message.substring(0, 500));
        }
    }

    public setDefaultValues() {

        //hide multi step clickable status bar
        $('.mat-horizontal-stepper-header-container').hide();

        //to avoid unnecessary vertical scroll when focusing autofill values in input.
        $(".wrapper").css("overflow-y", "auto");

        //to avoid horizontal scroll, Applying below style on root div
        $(".main-panel").css("overflow-x", "hidden");

        //Change hard coded value to config driven in later development
        this.maxAvailableDatesAllowed = 45;
        this.entranceCodeReminderMsg = 'Please ensure someone at least 18 years of age or older will be home.';
    }

    //#endregion

    
    //#region Address Confirm
    confirmAddressAgreed() {
        try {
            //this.isConfirmAddressPerformed = true;
            //this.insertDBTraceLog(LogType.Info, 'Address confirmation performed');

            if (this.accountDetails.isOrderEligibleToSchedule) {
                //Navigate to availability step when number of questions in qunre is zero (chances of disabling questionnaire in future)
                //When disabled - Below line helps to skip questionnaire screen.

                this.insertDBTraceLog(LogType.Info, 'Address confirmation performed & Navaigated to load availability');

                this.schedulingStepper.selectedIndex = 3;

                this.isQuestionnaireHasYes = false;

                this.showSpinner = true;
                //this.seedDate = this.datepipe.transform(Date.now(), "yyyy-MM-dd");

                //Prepate Availability Input
                this.prepareAvailabilityInput();

                //this.GetAvailability(this.seedDate, true);

            }
            else if (!this.accountDetails.isOrderEligibleToSchedule) {
                //show questionnaire step to show "Not eligible" message
                this.schedulingStepper.selectedIndex = 2;
            }
        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while confirming address, Error: ' + e.message.substring(0, 500));
        }
    }

    //#endregion

    //#region Application Config

    GetApplicationConfigs() {
        try {
            this.appCommonService.getApplicationConfigs().subscribe(ApiResult => {

                //console.log('ApplicationConfig ApiResult: ', ApiResult.data);            

                if (ApiResult.data != null) {

                    //this.appConfigurationDataResponse = ApiResult.data;

                    this.insertDBTraceLog(LogType.Info, 'Application configs fetched successfully');

                    ApiResult.data.forEach(configData => {
                        this.appConfigurationDataList.push(configData);
                    });

                    //Set Entrance Instruction Notes
                    this.entranceInstructionsList = this.appConfigurationDataList.filter(item => item.configurationType == 'Entrance Instruction Notes')
                        .map(cv => cv.configurationValue);

                    //Get CIS Specific Decoded order Type
                    this.cisOrderType = this.appConfigurationDataList.filter(item => (item.ldc == (this.ldc != 'AGLC' ? 'CCB' : this.ldc) && item.configurationType == 'CIS Order Decode' && item.configurationKey.toUpperCase() == this.orderType.toUpperCase()))
                        .map(cv => cv.configurationValue)[0];

                    this.emailToList = this.appConfigurationDataList.filter(item => (item.configurationKey == 'EmailTo'))
                        .map(cv => cv.configurationValue)[0];

                    this.timeOutPeriod = Number(this.appConfigurationDataList.filter(item => item.configurationKey == 'SessionTimeOut')
                        .map(cv => cv.configurationValue)[0]);

                    this.timeOutWarning = Number(this.appConfigurationDataList.filter(item => item.configurationKey == 'SessionTimeOutWarning')
                        .map(cv => cv.configurationValue)[0]);
                    
                    if (this.appConfigurationDataList.filter(item => (item.ldc == this.ldc && item.configurationKey == 'EnableAGLCSchedulingPortal'))
                        .map(cv => cv.configurationValue)[0] != null) {
                        this.aglcScheudlingPortalSwitch =
                            JSON.parse(this.appConfigurationDataList.filter(item => (item.ldc == this.ldc && item.configurationKey == 'EnableAGLCSchedulingPortal'))
                                .map(cv => cv.configurationValue)[0].toLowerCase());

                        //if switch is false, show invalid url error
                        if (this.ldc === 'AGLC' && !this.aglcScheudlingPortalSwitch) { this.invalidURLError = true; $('#divScheduling').hide(); }

                        //this is a temporary condition to block AGLC - Non-Rconnect scheduling. Need to implement LDC/OrderType mapping table 
                        //on eligible ordertypes enabled for specific market and create api around it read the values to decide valid url or not.
                        if (this.ldc === 'AGLC' && this.orderType.toUpperCase() != 'RECONNECT') { this.invalidURLError = true; $('#divScheduling').hide(); }
                    }

                    //set contactPhone on load
                    this.setContactPhoneNoAndHours();
                    this.getLDCFullName();

                    this.prepareAccountVerificationInput();

                    //Trigger timeout watch after configs load
                    this.triggerTimeOut();

                    this.isPageLoadReady = true;
                    this.showInitialSpinner = false;
                    //this.VerifyAccountAndOrderEligibility(stepper);

                }
                else {
                    this.insertDBTraceLog(LogType.Error, 'Error occured while fetching application configs, APIResult is null');
                    this.processError();
                }

            }, ApiResult => {
                //capture error
                if (this.http.isInvalidResult(ApiResult) || this.http.isErrorResult(ApiResult) || this.http.isFailureResult(ApiResult)) {
                    this.insertDBTraceLog(LogType.Error, 'Error occured while fetching application configs, APIResult is invalid');
                    this.processError();
                }
            });

        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while fetching application configs, Error: ' + e.message.substring(0, 500));
        }

    }

    //#endregion

    // #region Schedule Order

    private ScheduleOrder(stepper: MatStepper) {
        if (this.ldc != 'AGLC')
            this.ScheduleCCBOrder(stepper);
        else
            this.ScheduleAGLCOrder(stepper);
    }

    private ScheduleCCBOrder(stepper: MatStepper) {

        try {
            //perform validation using nonFormated Phone No.
            var nonFormartedPhoneNo: string = '';
            var updatedFieldInstructions: string = '';

            if (this.kmiPhoneNumber != '')
                nonFormartedPhoneNo = this.unmaskPhoneNumber(this.kmiPhoneNumber);

            if (nonFormartedPhoneNo != '') {
                if (nonFormartedPhoneNo === '' || (nonFormartedPhoneNo != '' && nonFormartedPhoneNo.length === 10))
                    this.kmiPhoneNumberValidationMsg = '';
                else
                    this.kmiPhoneNumberValidationMsg = 'Invalid Phone Number';
            }
            else {
                this.kmiPhoneNumberValidationMsg = 'Phone number is required';
            }

            if (this.kmiPhoneNumberValidationMsg === '') {

                this.showConfirmSpinner = true;

                if (!this.skipQuestionnaire && !this.isQuestionnaireHasYes) {
                    if (this.fieldInstructions != '')
                        this.fieldInstructions = this.fieldInstructions + '\n';

                    updatedFieldInstructions = this.fieldInstructions + 'No Illness ' + this.datepipe.transform(new Date(), 'MM/dd/yyyy');
                }
                else
                    updatedFieldInstructions = this.fieldInstructions;

                this.scheduleOrder = new ScheduleOrder();
                this.scheduleOrder.ldc = this.accountDetails.ldc;
                this.scheduleOrder.orderNumber = this.accountDetails.orderNumber;
                this.scheduleOrder.fieldInstructions = updatedFieldInstructions; //this.fieldInstructions;

                //GCMA specific fields
                this.scheduleOrder.scheduleDate = this.selectdScheduleDate;
                this.scheduleOrder.scheduleWindow = this.selectedScheduleWindow;

                //CCB specific fields
                this.scheduleOrder.premisesNumber = this.accountDetails.premiseNumber;
                this.scheduleOrder.appointmentStart = this.ccbAppointmentStart;
                this.scheduleOrder.appointmentEnd = this.ccbAppointmentEnd;
                this.scheduleOrder.personID = this.accountDetails.personID;
                this.scheduleOrder.isKMIEligible = this.accountDetails.isKMIEligible;
                this.scheduleOrder.kmiTextOptIn = this.isKMITextOptedIn;
                this.scheduleOrder.kmiPhoneNumber = this.kmiPhoneNumber;

                if (this.ldc === 'AGLC')
                    this.insertDBTraceLog(LogType.Info, 'Order scheduling initiated for Schedule Date:' + this.selectdScheduleDate + ', Schedule Window: ' + this.selectedScheduleWindow);
                else
                    this.insertDBTraceLog(LogType.Info, 'Order scheduling initiated for Appt Start:' + this.ccbAppointmentStart + ', Appt End: ' + this.ccbAppointmentEnd);

                this.insertDBTraceLog(LogType.Info, 'Order scheduling - KMI Opted In: ' + this.isKMITextOptedIn + ', KMI Ph No: ' + this.kmiPhoneNumber);

                //Invoke service call
                this.scheduleService.scheduleOrder(this.scheduleOrder).subscribe(ApiResult => {
                    if (ApiResult != null && ApiResult.statusCode == 200) {

                        if (this.ldc === 'AGLC')
                            this.insertDBTraceLog(LogType.Info, 'Order scheduling completed successfully for Schedule Date:' + this.selectdScheduleDate + ', Schedule Window: ' + this.selectedScheduleWindow);
                        else
                            this.insertDBTraceLog(LogType.Info, 'Order scheduling completed successfully for Appt Start:' + this.ccbAppointmentStart + ', Appt End: ' + this.ccbAppointmentEnd);

                        //Navigate to next page
                        this.showConfirmSpinner = false;
                        stepper.next();
                    }
                    else {
                        this.insertDBTraceLog(LogType.Error, 'Error occured while scheduling order, APIResult is not 200');
                        this.showConfirmSpinner = false;
                        this.processError();
                    }

                }, ApiResult => {
                    if (this.http.isInvalidResult(ApiResult) || this.http.isErrorResult(ApiResult) || this.http.isFailureResult(ApiResult)) {
                        this.insertDBTraceLog(LogType.Error, 'Error occured while scheduling order, APIResult is invalid');
                        this.showConfirmSpinner = false;
                        this.processError();
                    }
                });
            }
        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while scheduling order, Error: ' + e.message.substring(0, 500));
        }
    }

    private ScheduleAGLCOrder(stepper: MatStepper) {

        try {
            //perform validation using nonFormated Phone No.
            var nonFormartedPhoneNo: string = '';
            var updatedFieldInstructions: string = '';

            if (this.kmiPhoneNumber != '')
                nonFormartedPhoneNo = this.unmaskPhoneNumber(this.kmiPhoneNumber);

            if (nonFormartedPhoneNo != '') {
                if (nonFormartedPhoneNo === '' || (nonFormartedPhoneNo != '' && nonFormartedPhoneNo.length === 10))
                    this.kmiPhoneNumberValidationMsg = '';
                else
                    this.kmiPhoneNumberValidationMsg = 'Invalid Phone Number';
            }
            else {
                this.kmiPhoneNumberValidationMsg = 'Phone number is required';
            }

            if (this.requestorName.trim() === '')
                this.reqNameValidationMsg = 'Requestor name is required';
            else
                this.reqNameValidationMsg = '';

            if (this.kmiPhoneNumberValidationMsg === '' && this.reqNameValidationMsg === '') {

                this.showConfirmSpinner = true;

                if (this.fieldInstructions != '')
                        this.fieldInstructions = this.fieldInstructions + '\n';
                    updatedFieldInstructions = this.fieldInstructions;

                this.aglcScheduleOrder = new AGLCScheduleOrder();

                this.aglcScheduleOrder.accountNumber = this.accountNumber;
                this.aglcScheduleOrder.customerServiceRemarks = '';
                this.aglcScheduleOrder.entranceCode = '5';
                this.aglcScheduleOrder.entranceInstructions = 'Customer Onsite';
                this.aglcScheduleOrder.fieldInstructions = updatedFieldInstructions;
                this.aglcScheduleOrder.gateCode = this.gateCode;
                this.aglcScheduleOrder.intersectingStreet = this.intersectingStreet;
                this.aglcScheduleOrder.isMeterNotAccessible = false;
                this.aglcScheduleOrder.kmiCallbackOptIn = false;
                this.aglcScheduleOrder.kmiTextOptIn = this.isKMITextOptedIn;
                this.aglcScheduleOrder.marketerReferenceID = '';
                this.aglcScheduleOrder.premiseNumber = this.accountDetails.premiseNumber;
                this.aglcScheduleOrder.requestorName = this.requestorName;
                this.aglcScheduleOrder.requestorPhone = nonFormartedPhoneNo;
                this.aglcScheduleOrder.safetyQuestionAnswer1 = 'No';
                this.aglcScheduleOrder.safetyQuestionAnswer2 = 'No';
                this.aglcScheduleOrder.safetyQuestionAnswer3 = 'No';
                this.aglcScheduleOrder.safetyQuestionAnswer4 = '';
                this.aglcScheduleOrder.safetyQuestionAnswer5 = '';
                this.aglcScheduleOrder.safetyQuestionAnswer6 = '';
                this.aglcScheduleOrder.scheduleDate = this.selectdScheduleDate;
                this.aglcScheduleOrder.scheduleTime = '';
                this.aglcScheduleOrder.scheduleWindow = this.selectedScheduleWindow;
                this.aglcScheduleOrder.serviceOrderType = this.cisOrderType;
                this.aglcScheduleOrder.serviceOrderTypeDescription = '';
                this.aglcScheduleOrder.serviceOrderTypeReason = this.getServiceOrderReasonByOrder();
                this.aglcScheduleOrder.serviceOrderTypeReasonID = 1;
                this.aglcScheduleOrder.specialInstructions = '';
                this.aglcScheduleOrder.subdivisionName = this.subdivisionName;


                this.insertDBTraceLog(LogType.Info, 'Order scheduling initiated for Schedule Date:' + this.selectdScheduleDate + ', Schedule Window: ' + this.selectedScheduleWindow);
                this.insertDBTraceLog(LogType.Info, 'Order scheduling - KMI Opted In: ' + this.isKMITextOptedIn + ', KMI Ph No: ' + this.kmiPhoneNumber);


                //Invoke service call
                this.scheduleService.aglcScheduleOrder(this.aglcScheduleOrder).subscribe(ApiResult => {
                    //console.log('Amend Order API Result: ', ApiResult);
                    if (ApiResult != null && ApiResult.statusCode == 200) {

                        //console.log('AGLC Schedule Order API Result: ', ApiResult);
                        this.insertDBTraceLog(LogType.Info, 'Order scheduling completed successfully for Schedule Date:' + this.selectdScheduleDate + ', Schedule Window: ' + this.selectedScheduleWindow);

                        //Navigate to next page
                        this.showConfirmSpinner = false;
                        stepper.next();
                    }
                    else {
                        this.insertDBTraceLog(LogType.Error, 'Error occured while scheduling order, APIResult is not 200');
                        this.showConfirmSpinner = false;
                        this.processError();
                    }

                }, ApiResult => {
                    if (this.http.isInvalidResult(ApiResult) || this.http.isErrorResult(ApiResult) || this.http.isFailureResult(ApiResult)) {
                        this.insertDBTraceLog(LogType.Error, 'Error occured while scheduling order, APIResult is invalid');
                        this.showConfirmSpinner = false;
                        this.processError();
                    }
                });
            }
        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while scheduling order, Error: ' + e.message.substring(0, 500));
        }
    }

    // #region Other Button Clicks    

   public navigateToAccountVerification() {
        try {
            this.showLogOut = false;
            this.schedulingStepper.selectedIndex = 0;

            //Set this flag to default for fresh new calls
            this.ldc = this.route.snapshot.url.length > 1 ? this.route.snapshot.url[1].path.toUpperCase() : '';
            this.isPageLoadReady = true;
            this.isAvailabilityCallCompleted = false;
            this.showConfirmSpinner = false;
            this.showSpinner = false;
            this.fieldInstructions = '';
            this.kmiPhoneNumber = '';
            this.isKMITextOptedIn = false;
            this.isValidateAccountPerformed = false;
            //this.isConfirmAddressPerformed = false;
            this.kmiPhoneNumberValidationMsg = '';
            this.invalidURLError = false;
            this.showError = false;
            this.isSentinelForceWindowEligible = true;

            this.isQuestionnaireHasYes = true;
          
            //Stop session timeout on home page
            this.sessionExpired = true;
            this.sessionTimeoutWarningMsg = '';

            $('#divScheduling').show();

            //console.log('this.ldc: ', this.ldc);
            this.insertDBTraceLog(LogType.Info, 'Navigated to home screen');
        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while navigating back to Account verification, Error: ' + e.message.substring(0, 500));
        }
    }


    determineNextAfterAccountVerificationFromChild($event) {
        try {

            this.schedulingStepper.next();
            //show logout button from second screen onwards
            this.showLogOut = true;
            this.showSpinner = false;

            //reset session expiry
            this.sessionExpired = false;
        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while determining schedule after account verification, Error: ' + e.message.substring(0, 500));
        }

    }

    // #endregion

    // #region Helper Methods

    processError(): void {
        this.showError = true;
        this.showInitialSpinner = false;
        this.showSpinner = false;
        this.showTimeSlotLoadingSpinner = false;
        this.showConfirmSpinner = false;

        //to hide content container's borde
        $('#divScheduling').hide();
        //$('.mat-horizontal-content-container').hide();
    }

    private processErrorFromChild($event) {
        this.processError();
    }

    private formatPhoneNumber(phoneNumberString: string) {
        if (phoneNumberString.length == 10) {
            //reformat and return phone number
            return phoneNumberString.replace(/(\d{3})(\d{3})(\d{4})/, "$1.$2.$3");
        }
        return phoneNumberString
    }

    private setRouteParameters() {
        var encodedURLfound = false;

        this.route.queryParams.subscribe(params => {
            if (params['qc'] != null) {
                encodedURLfound = true;
                var decodedQS = atob(params['qc']);
                var qParams = new URL('https://dummyURL.com?' + decodedQS).searchParams
                this.ldc = qParams.get('LDC').trim() || '';
                this.orderType = qParams.get('ORD').trim() || '';
                this.acntNumberFromURL = qParams.get('ACT').trim() || '';
                this.urlSource = params['s'] || '';
            }
        });

        if (this.route.snapshot.url.length > 1 && !encodedURLfound) {

            this.ldc = this.route.snapshot.url[1].path.trim().toUpperCase();
            this.orderType = this.route.snapshot.url[2].path.trim();

            //get additional params from URL
            if (this.route.snapshot.url.length > 3)
                this.acntNumberFromURL = this.route.snapshot.url[3].path;
            if (this.route.snapshot.url.length > 4) //SQ from QRCode, ST from Text
                this.urlSource = this.route.snapshot.url[4].path;
        }

        //when ldc is "IL", consider it as "NG"
        if (this.ldc === "IL")
            this.ldc = "NG";
    }

    public setContactPhoneNoAndHours() {

        this.contactPhoneNo = this.appConfigurationDataList.filter(item => (item.ldc == this.ldc && item.configurationType == 'Contact Phone Number'))
            .map(cv => cv.configurationValue)[0];

        this.contactHours = this.appConfigurationDataList.filter(item => (item.ldc == this.ldc && item.configurationType == 'Contact Hours'))
            .map(cv => cv.configurationValue)[0];
    }

    public unmaskPhoneNumber(val) {
        return val.replace(/\D+/g, '');
    }
    
    private getLDCFullName() {
        if (this.ldc === 'NG' || this.ldc === 'IL')
            this.ldcFullName = 'Nicor Gas';
        else if (this.ldc === 'VNG')
            this.ldcFullName = 'Virginia Natural Gas';
        else if (this.ldc === 'CGC')
            this.ldcFullName = 'Chattanooga Gas';
        else if (this.ldc === 'AGLC')
            this.ldcFullName = 'Southern Company Gas';
    }

    public determineKMITextOptIn(phValue: string) {
        if (phValue != '')
            this.isKMITextOptedIn = true;
        else
            this.isKMITextOptedIn = false;
    }
        
   
    private getSpecialMessagesByOrder() {
        try {

            switch (this.orderType.toLocaleUpperCase()) {
                case 'RECONNECT':
                    this.specialFeeMsg = 'A reconnect fee may apply.';
                    break;

                default: {
                    this.specialFeeMsg = '';
                    break;
                }
            }
        }
        catch (e) {
            this.insertDBTraceLog(LogType.Error, 'Exception occured while checking sentinel force window, Error: ' + e.message.substring(0, 5000));
        }
    }
    
    private insertDBTraceLog(logType: string, logMessage: string) {

        this.dbTraceLog = new DBTraceLog();

        this.dbTraceLog.portalTypeID = 3; //Scheduling Portal
        this.dbTraceLog.ldc = this.accountDetails != null ? this.accountDetails.ldc : this.ldc;
        this.dbTraceLog.kmiUrlCode = '';
        this.dbTraceLog.issuingApOrderID = this.accountDetails != null ? this.accountDetails.orderNumber : '';
        this.dbTraceLog.orderType = this.cisOrderType;
        this.dbTraceLog.logReferenceID = this.logReferenceID;
        this.dbTraceLog.logType = logType;
        this.dbTraceLog.logMessage = logMessage;
        this.dbTraceLog.emailToList = this.emailToList;

        super.InsertDBTraceLogThruBase(this.dbTraceLog);
    }

    private prepareAvailabilityInput() {

        this.availabilityInput.ldc = this.accountDetails.ldc;
        this.availabilityInput.kmiUrlCode = '';
        this.availabilityInput.orderNumber = this.accountDetails.orderNumber;
        this.availabilityInput.orderType = this.cisOrderType;
        this.availabilityInput.premisesNumber = this.accountDetails.premiseNumber;
        if (this.accountDetails.ldc != 'AGLC')
            this.availabilityInput.entranceInstructionCode = 'CUON';
        else
            this.availabilityInput.entranceInstructionCode = 'CustomerOnSite';
        this.availabilityInput.entranceInstructionProfile = 'ResTwoAndFourAndEightHour';
        this.availabilityInput.logReferenceID = this.logReferenceID;
        this.availabilityInput.portalTypeID = 3; //Schedule
        this.availabilityInput.entranceCodeReminderMsg = this.entranceCodeReminderMsg;
        this.availabilityInput.emailToList = this.emailToList;
        this.availabilityInput.appointmentType = 'Issue';

        this.availabilityInput.accountNumber = this.accountNumber;
        this.availabilityInput.activityOrProblemType = ''; //this will change when we expand to Misc/Dist order types
        this.availabilityInput.isOverride = false;
        this.availabilityInput.orderCategory = ''; //this will change when we expand to Misc/Dist order types
        this.availabilityInput.premisesNumber = this.accountDetails.premiseNumber;
        this.availabilityInput.serviceOrderActiontype = 'Issue';
        this.availabilityInput.serviceOrderReason = 'CustomerPaidBill';
        this.availabilityInput.serviceOrderType = this.cisOrderType;
        this.availabilityInput.specialDateCodeID = 'None';
    }

    private recieveAvailabilitySelection($event) {
        this.availabilityOutput = $event;

        this.selectedTimeSlot = this.availabilityOutput.selectedTimeSlot;
        this.selectedTimeSlotWindow = this.availabilityOutput.selectedTimeSlotWindow;
        this.selectdScheduleDate = this.availabilityOutput.selectedScheduleDate;
        this.selectedScheduleWindow = this.availabilityOutput.selectedScheduleWindow;
        this.ccbAppointmentStart = this.availabilityOutput.ccbAppointmentStart;
        this.ccbAppointmentEnd = this.availabilityOutput.ccbAppointmentEnd;

        //prepare appt confirmation input for child control
        this.prepareAppointmentConfirmationInput();
    }

    private prepareAccountVerificationInput() {

        this.accountVerificationInput.acntNumberFromURL = this.acntNumberFromURL;
        this.accountVerificationInput.cisOrderType = this.cisOrderType;        
        this.accountVerificationInput.ldc = this.ldc;        
        this.accountVerificationInput.logReferenceID = this.logReferenceID;
        this.accountVerificationInput.portalTypeID = 3; //Schedule        
        this.accountVerificationInput.emailToList = this.emailToList;
        this.accountVerificationInput.contactHours = this.contactHours;
        this.accountVerificationInput.contactPhoneNo = this.contactPhoneNo;
    }
    private recieveAccountVerificationOutput($event) {
        this.accountVerificationOutput = $event;

        this.accountDetails = this.accountVerificationOutput.accountDetails;
        this.accountNumber = this.accountVerificationOutput.accountNumber;        
        this.ldc = this.accountVerificationOutput.accountDetails.ldc;

        this.determineNextAfterAccountVerificationFromChild($event);
    }

    private prepareAppointmentConfirmationInput() {

        this.appointmentConfirmationInput.selectedTimeSlot = this.selectedTimeSlot;
        this.appointmentConfirmationInput.selectedTimeSlotWindow = this.selectedTimeSlotWindow;
        this.appointmentConfirmationInput.entranceInstructionsList = this.entranceInstructionsList;
        this.appointmentConfirmationInput.specialFeeMsg = this.specialFeeMsg;
        this.appointmentConfirmationInput.ldc = this.ldc;
        this.appointmentConfirmationInput.logReferenceID = this.logReferenceID;
        this.appointmentConfirmationInput.portalTypeID = 3; //Schedule        
        this.appointmentConfirmationInput.emailToList = this.emailToList;
    }

    private getServiceOrderReasonByOrder(): string {
        var reasonType = '';
        switch (this.orderType.toLocaleUpperCase()) {
            case 'RECONNECT':
                reasonType = 'CustomerPaidBill';
                break;

            default: {
                reasonType = '';
                break;
            }
        }

        return reasonType;

    }
    
    //#region Session TimeOut

    private triggerTimeOut() {

        this.bnIdle.startWatching(this.timeOutPeriod - this.timeOutWarning).subscribe((res) => {
            if (res && !this.sessionExpired) {
                //start countdown
                this.startCountdown(this.timeOutWarning);
                //navigate home once countdown finishes
                this.userActivity = setTimeout(this.navigateHome.bind(this), this.timeOutWarning * 1000);
            }
        })
    }
    
    navigateHome = () => {
        //console.log("session expired");
        this.navigateToAccountVerification();

        //Stop session timeout on home page
        this.sessionExpired = true;
        this.sessionTimeoutWarningMsg = '';
    }

    private startCountdown(seconds) {
        let counter = seconds;

        this.interval = setInterval(() => {
            this.sessionTimeoutWarningMsg = 'Session expiring in ' + counter;
            counter--;

            if (counter < 0) {
                clearInterval(this.interval);
                this.sessionTimeoutWarningMsg = '';
            }
        }, 1000);
    }

    //stop countdown on user activity
    @HostListener('document:keydown', ['$event'])
    @HostListener('window:mousemove', ['$event'])
    @HostListener('window:wheel', ['$event'])
    @HostListener('touchstart', ['$event'])
    onEvent(event) {
        if (this.sessionTimeoutWarningMsg != '') {
            clearTimeout(this.userActivity);
            clearInterval(this.interval);
            this.sessionTimeoutWarningMsg = '';
        }
    }    

    //#endregion

    // #endregion

}
